import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  //Bunga : lagi didepan rumah kalau didkeetin trigger auto next 'stage;, dia bilang ulang tahn
  {
    x: 5820,
    y: 2250,
    name: 'Diana',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    dialogTree: {
      startDialogId: 'diana_1',
      nodes: {
        diana_1: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Aku takut kak.. Apa yang harus kita lakukan!`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/diana_c.png',
          isEnd: true
        },
        //suruh tenang dulu. jelasin
      },
    },
  },
  {
    x: 5720,
    y: 2320,
    name: 'Holga',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/holga_up.png', // Use NPC image
    repeatable : false,
    dialogTree: {
      startDialogId: 'holga_1',
      nodes: {
        holga_1: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Apa yang terjadi.... Sungguh aku tidak percaya`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_s.png',
          nextDialogId: 'holga_2',
        },
        holga_2: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Sondakh ku tercinta, gadis paling cantik di dunia...`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_s.png',
          nextDialogId: 'holga_3',
        },
        holga_3: {
          id: 'bar_1',
          speaker: '',
          text: '',
          characterImage: '/assets/character/v2/holga_s.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId : "bar_1",
          choices: [
            {
              text: 'Saya turut berduka cita bu',
              storyActions : [
                { type: 'addCustomValue', value: {key : "general_karma", value : 1} },
                { type: 'addCustomValue', value: {key : "holga_affinity", value : 1} }
              ],
              nextDialogId: 'holga_a1',
            },
            {
              text: 'Bukan Elsa maupun Diana pembunuh Sondakh',
              storyActions : [
                { type: 'addCustomValue', value: {key : "holga_affinity", value : -1} }
              ],
              nextDialogId: 'holga_b1',
            },
            {
              text: 'Kapan terakhir ibu melihat Sondakh?',
              nextDialogId: 'holga_a2',
            },
          ],
        },
        holga_b1: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Aku tidak tahu apa yang kau lihat nak.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga.png',
          nextDialogId: 'holga_b2',
        },
        holga_b2: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Temanmu, Elsa, jelas-jelas sangat mencurigakan.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_a.png',
          // nextDialogId: 'holga_b2',
          isEnd : true
        },
        holga_a1: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Terima kasih nak`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_s.png',
          nextDialogId: 'holga_a2',
        },
        holga_a2: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Saya sedang dirumah terakhir kali melihat Sondakh`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_s.png',
          nextDialogId: 'holga_a3',
        },
        holga_a3: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Saya berangkat ke gereja.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_s.png',
          nextDialogId: 'holga_a4',
        },
        holga_a4: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Kembali ke rumah, dia sudah tidak dirumah.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_s.png',
          nextDialogId: 'holga_a5',
        },
        holga_a5: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Selanjutnya yang saya tahu, dia sudah tidak ada dimana-mana`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_s.png',
          nextDialogId: 'holga_a6',
        },
        holga_a6: {
          id: 'diana_1',
          speaker: 'Holga',
          text: `Kenapa ini terjadi ke Sondakh ku!`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/holga_s.png',
          nextDialogId: 'holga_3',
          isEnd : true
        },
        //suruh tenang dulu. jelasin
      },
    },
  },
  {
    x: 5780,
    y: 2280,
    name: '',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_sondakh_dead.png', // Use NPC image
    repeatable  :true,
    dialogTree: {
      startDialogId: 'sondakh_1',
      nodes: {
        sondakh_1: {
          id: 'bunga_part2_1',
          speaker: 'Yan',
          text: `Ini adalah... Sondakh?`,
          backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
          nextDialogId : "sondakh_2",
        },
        sondakh_2: {
          id: 'bunga_part2_1',
          speaker: 'Yan',
          text: `Tidak bisa dikenali lagi...`,
          backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
          nextDialogId : "sondakh_3",
        },
        sondakh_3: {
          id: 'bunga_part2_1',
          speaker: 'Yan',
          text: `Sebaiknya kita teliti baik-baik.`,
          backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
          nextDialogId : "sondakh_choice",
        },
        sondakh_4: {
          id: 'bunga_part2_1',
          speaker: 'Yan',
          text: `Sebaiknya kita ke Romo untuk memberi tahu bahwa investigasi sudah selesai`,
          backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
          isEnd : true
        },
        sondakh_choice: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Sebaiknya kita teliti baik-baik.`,
          backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
          nextDialogId : "sondakh_4",
          clickables: [
            {
              text: 'Perhatikan badan Sondakh',
              nextDialogId: 'sondakh_a1',
              locationX: 38, locationY: 70
            },
            {
              text: 'Perhatikan baju sondakh',
              nextDialogId: 'sondakh_b1',
              locationX: 55, locationY: 70
            },
            {
              text: 'Perhatikan darah sondakh',
              nextDialogId: 'sondakh_c1',
              locationX: 25, locationY: 45
            },
            {
              text: 'Perhatikan Barang',
              nextDialogId: 'sondakh_d1',
              locationX: 15, locationY: 15
            },
          ],
        },

        sondakh_d1: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Ada sesuatu di dekat Sondakh`,
          backgroundImage: '/assets/cutscene/death_sondakh_kalung.ktx2',
          nextDialogId : "sondakh_d2",
        },
        sondakh_d2: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Seperti sebuah kalung yang sudah putus`,
          backgroundImage: '/assets/cutscene/death_sondakh_kalung.ktx2',
          nextDialogId : "sondakh_d3",
        },
        sondakh_d3: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Sepertinya aku pernah melihat kalung ini sebelumnya`,
          backgroundImage: '/assets/cutscene/death_sondakh_kalung.ktx2',
          nextDialogId : "sondakh_choice",
        },

        sondakh_a1: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Seluruh badan Sondakh menyusut dan mengering.`,
          backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.ktx2',
          nextDialogId : "sondakh_a2",
        },
        sondakh_a2: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Tidak ada daging tersisa, hanya kulit yang menempel ke tulang`,
          backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.ktx2',
          nextDialogId : "sondakh_choice",
        },
        sondakh_b1: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Bagian kanan baju Sondakh koyak`,
          backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.ktx2',
          nextDialogId : "sondakh_b2",
        },
        sondakh_b2: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Apakah kita bisa menemukan sobekan baju ini?`,
          backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.ktx2',
          nextDialogId : "sondakh_choice",
        },
        sondakh_c1: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Darah muncul dari mulut, mata, dan seluruh tempat lain.`,
          backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
          nextDialogId : "sondakh_c2",
        },
        sondakh_c2: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Air-air dipinggir danau ini juga penuh dengan darah yang sama`,
          backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
          nextDialogId : "sondakh_choice",
        },
      },
    },
  },
  {
    x: 3900,
    y: 2500,
    name: 'Bunga',
    hideOnState : ['BUNGA_ON_SONDAKH_DEATH'],
    color: 0x9932cc, // Dark orchid
    flipSprite : true,
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Halo Yan. Ada kejadian apa?`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga_2',
        },
        bunga_2: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Aku mendengar keributan dari jauh`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga_3',
        },
        bunga_3: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Aku mendengar keributan dari jauh`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          choices: [
            {
              text: 'Diana dan Elsa menemukan mayat di sisi lain danau.',
              nextDialogId: 'bunga_4',
            },
            {
              text: 'Sebaiknya kita bergegas. Ada mayat ditemukan di sisi lain danau.',
              nextDialogId: 'bunga_4',
            }
          ],
        },
        bunga_4: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Mayat? Apa yang terjadi?`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga_p.png',
          nextDialogId: 'bunga_5',
        },
        bunga_5: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Aku harus segera kesana`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga_p.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 5950,
    y: 2370,
    name: 'Ato',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_ato.png', // Use NPC image
    dialogTree: {
      startDialogId: 'ato_1',
      nodes: {
        ato_1: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Apa yang sedang terjadi...`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/ato.png',
          nextDialogId : "ato_2"
        },
        ato_2: {
          id: 'ato_2',
          speaker: 'Ato',
          text: `Apakah gadis kota baru itu?`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/ato.png',
          nextDialogId : "ato_3"
        },
        ato_3: {
          id: 'ato_3',
          speaker: 'Ato',
          text: `Siapapun dalang dibalik kejadian ini tidak akan kita maafkan!`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/ato_a.png',
          isEnd : true
        },
        //suruh tenang dulu. jelasin
      },
    },
  },
  {
    x: 5620,
    y: 2370,
    name: 'Bunga',
    flipSprite : true,
    color: 0x9932cc, // Dark orchid
    hideOnState : ['BUNGA_NOT_ON_SONDAKH_DEATH'],
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Ya ampun Yan.. Apa yang terjadi`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga_p.png',
          nextDialogId : "ato_2",
          isEnd : true
        },
        //suruh tenang dulu. jelasin
      },
    },
  },
  {
    x: 5920,
    y: 2150,
    name: 'Romo Darius',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_darius.png', // Use NPC image
    repeatable : true,
    dialogTree: {
      startDialogId: 'darius_1',
      nodes: {
        darius_1: {
          id: 'darius_1',
          speaker: 'Romo Darius',
          text: `Sangat malang sekali kejadian ini.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/darius.png',
          nextDialogId : "darius_2"
        },
        darius_2: {
          id: 'darius_2',
          speaker: 'Romo Darius',
          text: `Sebaiknya kita cepat kembali ke desa untuk memberikan prosesi pemakaman, agar jiwanya damai.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/darius.png',
          nextDialogId : "darius_3"
        },
        darius_3: {
          id: 'darius_3',
          speaker: 'Romo Darius',
          text: `Apakah kamu siap?`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/darius.png',
          nextDialogId : "darius_4"
        },
        darius_4: {
          id: 'darius_3',
          speaker: 'Romo Darius',
          text: ``,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/darius.png',
          choices: [
            {
              text: 'Ayo kita cepat kembali ke desa.',
              nextDialogId: 'part5_op0',
            },
            {
              text: 'Aku masih ingin mencari tahu apa yang terjadi',
              nextDialogId: 'darius_5',
              isEnd : true
            }
          ],
        },
        part5_op0: {
          id: 'part5_op1',
          speaker: '',
          text: ``,
          sfx: "",
          backgroundImage: '/assets/cutscene/black.ktx2',
          nextDialogId: 'part5_op2',
          fade : true,
          autoplay : 1.5,
        },
        part5_op1: {
          id: 'part5_op1',
          speaker: 'Romo Darius',
          text: `Terima kasih atas bantuan warga desa`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          fade : true,
          nextDialogId: 'part5_op2',
        },
        part5_op2: {
          id: 'part5_op2',
          speaker: 'Romo Darius',
          text: `Mayat Sondakh sudah kita pindahkan ke dalam gereja.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'part5_op3',
        },
        part5_op3: {
          id: 'part5_op2',
          speaker: 'Romo Darius',
          text: `Mohon semua bantu doa untuk kedamaian Sondakh dan yang ditinggalkan.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'part5_op4',
        },
        part5_op4: {
          id: 'part5_op2',
          speaker: 'Romo Darius',
          text: `Amin`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'part5_op5',
        },
        part5_op5: {
          id: 'part5_op2',
          speaker: 'Diana',
          text: `Aku masih syok dan tidak percaya....`,
          characterImage: '/assets/character/v2/diana_s.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'part5_op8',
        },
        part5_op8: {
          id: 'part5_op2',
          speaker: 'Elsa',
          text: `Aku juga sangat sedih`,
          characterImage: '/assets/character/v2/elsa_s.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'part5_op9',
        },
        part5_op9: {
          id: 'part5_op2',
          speaker: 'Elsa',
          text: `Tapi warga desa seperti Pak Ato dan Bu Holga, kenapa mereka langsung menyalahkan aku` ,
          characterImage: '/assets/character/v2/elsa_s.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'part5_op10',
        },
        part5_op10: {
          id: 'part5_op2',
          speaker: 'Diana',
          text: `Walaupun kita pertama kali disana... bukan berarti kita yang bertanggung jawab...` ,
          characterImage: '/assets/character/v2/diana_s.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          nextDialogId: 'part5_op11',
        },
        part5_op11: {
          id: 'part5_op2',
          speaker: 'Diana',
          text: `Kak Yan, apa bisa bantu bicara ke orang-orang desa` ,
          characterImage: '/assets/character/v2/diana_s.png',
          backgroundImage: '/assets/backdrop/gereja.ktx2',
          choices: [
            {
              text: 'Tidak ada salahnya mencoba',
              nextDialogId: 'part5_op8',
              storyAction: { type: 'nextDay', value: 1 },
              isEnd : true
              //Add hostility
            },
            {
              text: 'Pasti, coba aku bicarakan dengan mereka.',
              nextDialogId: 'part5_op8',
              storyAction: { type: 'nextDay', value: 1 },
              isEnd : true
            },
          ],
        },
      },
    },
  },
];

export default config;
